/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorTextSubtitle from 'base/components/labrador/TextSubtitle';

export const DynamicLabradorTextSubtitle: typeof LabradorTextSubtitle = (props) => {
    return <ErrorBoundary><LabradorTextSubtitle {...props} /></ErrorBoundary>;
}
export type DynamicLabradorTextSubtitleProps = PropsFromComponent<typeof LabradorTextSubtitle>;
